import Head from 'next/head';
import Refund from '../components/Refund/[slug].js';

export default function refund() {
    return (
        <>
            <Head>
                <title>Refund Policy – NEET Support</title>
                <meta
                    name="description"
                    content="View NEET Support's Refund Policy to understand eligibility, cancellation process, and refund conditions for our services."
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://neetsupport.com/refund-policy" />
            </Head>
            <Refund />
        </>
    );
}
